import { render, staticRenderFns } from "./bindstandard.vue?vue&type=template&id=080285f2&"
import script from "./bindstandard.vue?vue&type=script&lang=js&"
export * from "./bindstandard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports